import { render } from "./AddCattle.vue?vue&type=template&id=79bc0941&scoped=true"
import script from "./AddCattle.vue?vue&type=script&lang=js"
export * from "./AddCattle.vue?vue&type=script&lang=js"

import "./AddCattle.vue?vue&type=style&index=0&id=79bc0941&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79bc0941"]])

export default __exports__